'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _webfontloader = require('webfontloader');

var WebFont = _interopRequireWildcard(_webfontloader);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

var _KeyboardHoverOnlyDiv = require('../utils/KeyboardHoverOnlyDiv');

var _KeyboardHoverOnlyDiv2 = _interopRequireDefault(_KeyboardHoverOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var TAB_BAR_ITEM_ACTIVE_CLASS = '.a-tab-bar-item.active';
var FIRST_ITEM_LEFT_MARGIN = 5;

var TabBar = function (_Component) {
  _inherits(TabBar, _Component);

  function TabBar(props) {
    _classCallCheck(this, TabBar);

    var _this = _possibleConstructorReturn(this, (TabBar.__proto__ || Object.getPrototypeOf(TabBar)).call(this, props));

    _this.getMaxOffset = function () {
      var tabbarScroller = _this.tabbarScroller;
      var tabbar = _this.tabbar;
      if (!tabbarScroller || !tabbar) return -1;

      var tabbarBox = tabbar.getBoundingClientRect();
      return tabbarScroller.scrollWidth - tabbarBox.width;
    };

    _this.setCurrTabInitPos = function () {
      var showPrevNext = _this.state.showPrevNext;

      var tabbarScroller = _this.tabbarScroller;
      // show left/right scroll icons or not
      if (!showPrevNext) {
        tabbarScroller.style.left = '';
        return;
      }
      var maxOffset = _this.getMaxOffset();
      var prev = void 0,
          next = void 0;
      if (maxOffset === -1) return;

      var leftOffset = void 0;
      var currTabItem = tabbarScroller.querySelector(TAB_BAR_ITEM_ACTIVE_CLASS);
      if (!currTabItem) return;
      var currTabItemBox = currTabItem.getBoundingClientRect();
      var tabbarScrollerBox = tabbarScroller.getBoundingClientRect();
      var actualOffset = currTabItemBox.left - tabbarScrollerBox.left;
      // there may exist precision issues on different browsers
      if (actualOffset <= 0.01 + FIRST_ITEM_LEFT_MARGIN) {
        leftOffset = 0;
        prev = false;
        next = true;
      } else if (Math.abs(actualOffset) >= maxOffset) {
        leftOffset = -maxOffset;
        prev = true;
        next = false;
      } else {
        leftOffset = -actualOffset;
        prev = true;
        next = true;
      }

      _this.tabbarScroller.style.left = leftOffset + 'px';
      _this.setState({
        prev: prev,
        next: next
      });
    };

    _this.setPrevNext = function () {
      var tabbarWrapper = _this.tabbarWrapper;
      var tabbarScroller = _this.tabbarScroller;
      if (!tabbarWrapper || !tabbarScroller) return;
      var tabbarWrapperWidth = _this.tabbarWrapper.getBoundingClientRect().width;
      var tabbarScrollerWidth = _this.tabbarScroller.getBoundingClientRect().width;
      // a. add/remove scroll icons
      _this.setState({
        showPrevNext: tabbarScrollerWidth > tabbarWrapperWidth
      }, function () {
        _this.setCurrTabInitPos();
      });
      // b. scroll currTabItem to the right position
    };

    _this.calcIndicatorStyle = function () {
      var tabbarScroller = _this.tabbarScroller;
      if (!tabbarScroller) return;
      var tabbarScrollerBox = tabbarScroller.getBoundingClientRect();
      var currTabItem = tabbarScroller.querySelector(TAB_BAR_ITEM_ACTIVE_CLASS);
      if (!currTabItem) return;
      var currTabItemBox = currTabItem.getBoundingClientRect();
      var width = currTabItem.scrollWidth;
      var left = Math.round(currTabItemBox.left - tabbarScrollerBox.left);
      _this.setState({
        indicatorStyle: {
          transform: 'translate3d(' + left + 'px, -2px, 0px)',
          // scrollWidth is calculated like Math.floor, so widht 57.38 goes to scrollWidth 57
          // add 1 more pixel to cover focus visual effect.
          width: width + 1
        }
      });
    };

    _this.getTabBarOffset = function () {
      if (!_this.tabbarScroller.style.left) return 0;
      return parseFloat(_this.tabbarScroller.style.left.replace('px', ''), 10);
    };

    _this.checkPrevNext = function (offset, maxOffset) {
      var next = true;
      var prev = true;
      if (offset >= 0) {
        prev = false;
      } else if (maxOffset && Math.abs(offset) + 1 >= maxOffset) {
        next = false;
      }
      return { next: next, prev: prev };
    };

    _this.goPrev = function () {
      var tabbarScroller = _this.tabbarScroller;
      if (!tabbarScroller) return;

      var leftOffset = _this.getTabBarOffset();
      var moveDist = tabbarScroller.scrollWidth / _this.props.children.length;
      leftOffset += Math.round(moveDist);

      var _this$checkPrevNext = _this.checkPrevNext(leftOffset),
          prev = _this$checkPrevNext.prev,
          next = _this$checkPrevNext.next;

      if (!prev) {
        leftOffset = 0;
      }

      _this.tabbarScroller.style.left = leftOffset + 'px';
      _this.setState({
        prev: prev,
        next: next
      });
    };

    _this.goNext = function () {
      var tabbarScroller = _this.tabbarScroller;
      if (!tabbarScroller) return;

      var leftOffset = _this.getTabBarOffset();
      var moveDist = tabbarScroller.scrollWidth / _this.props.children.length;
      leftOffset -= Math.round(moveDist);
      var maxOffset = _this.getMaxOffset();

      var _this$checkPrevNext2 = _this.checkPrevNext(leftOffset, maxOffset),
          prev = _this$checkPrevNext2.prev,
          next = _this$checkPrevNext2.next;

      if (!next) {
        leftOffset = -maxOffset;
      }

      _this.tabbarScroller.style.left = leftOffset + 'px';
      _this.setState({
        prev: prev,
        next: next
      });
    };

    _this.scrollToActiveTab = function () {
      if (!_this.state.showPrevNext) return;
      var tabbarScroller = _this.tabbarScroller;
      var tabbar = _this.tabbar;
      if (!tabbarScroller || !tabbar) return;
      var currTabItem = tabbarScroller.querySelector(TAB_BAR_ITEM_ACTIVE_CLASS);
      if (!currTabItem) return;
      var currTabItemBox = currTabItem.getBoundingClientRect();
      var tabbarBox = tabbar.getBoundingClientRect();
      var tabbarScrollerBox = tabbarScroller.getBoundingClientRect();
      var offset = _this.getTabBarOffset();
      if (currTabItemBox.right > tabbarBox.right) {
        offset = -(currTabItemBox.left - tabbarScrollerBox.left + currTabItemBox.width - tabbarBox.width);
      } else if (currTabItemBox.left < tabbarBox.left) {
        offset = -(currTabItemBox.left - tabbarScrollerBox.left);
      }

      var _this$checkPrevNext3 = _this.checkPrevNext(offset, _this.getMaxOffset()),
          prev = _this$checkPrevNext3.prev,
          next = _this$checkPrevNext3.next;

      tabbarScroller.style.left = offset + 'px';
      _this.setState({ prev: prev, next: next });
    };

    _this.scrollToFocusTab = function () {

      var tabbarScroller = _this.tabbarScroller;
      var tabbar = _this.tabbar;
      if (!tabbarScroller || !tabbar) return;
      var tabbarBox = tabbar.getBoundingClientRect();
      var tabbarScrollerBox = tabbarScroller.getBoundingClientRect();
      var focusedItem = tabbarScroller.querySelector('.a-tab-bar-item:focus');
      var focusedItemBox = focusedItem.getBoundingClientRect();
      var maxLeftOffset = tabbarScroller.scrollWidth - tabbarBox.width;
      var leftOffset = tabbarScrollerBox.left - focusedItemBox.left;
      if (Math.abs(leftOffset) <= maxLeftOffset) {
        tabbarScroller.style.left = 0;
        _this.setState({
          prev: true
        });
      } else {
        tabbarScroller.style.left = '-' + maxLeftOffset + 'px';
        _this.setState({
          next: false
        });
      }
    };

    _this.renderTabBarItems = function (child, index) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          onTabClick = _this$props.onTabClick,
          value = _this$props.value;

      var _ref = child ? child.props || {} : {},
          label = _ref.label,
          icon = _ref.icon,
          itemValue = _ref.value,
          children = _ref.children,
          closable = _ref.closable,
          isLoading = _ref.isLoading,
          isLoadingBlocking = _ref.isLoadingBlocking,
          close = _ref.close,
          rest = _objectWithoutProperties(_ref, ['label', 'icon', 'value', 'children', 'closable', 'isLoading', 'isLoadingBlocking', 'close']);

      var key = typeof itemValue === 'undefined' ? index : itemValue;
      var active = value === key;
      var tabClass = (0, _classnames4.default)('a-tab-bar-item', _defineProperty({}, 'active', active));

      if (typeof rest.id === 'string') rest.id = 'tab-bar-' + rest.id;
      return [_react2.default.createElement(
        _KeyboardHoverOnlyDiv2.default,
        Object.assign({
          isLi: true,
          className: tabClass,
          onClick: function onClick(e) {
            onTabClick && onTabClick(e, key, label);
          },
          onKeyDown: function (_onKeyDown) {
            function onKeyDown(_x) {
              return _onKeyDown.apply(this, arguments);
            }

            onKeyDown.toString = function () {
              return _onKeyDown.toString();
            };

            return onKeyDown;
          }(function (e) {
            onKeyDown && onKeyDown(e, key, label);
          }),
          onKeyUp: function onKeyUp(e) {
            // scroll to the right tab when tab key pressed
            if (e.key === "Tab" && e.target.nodeName === "LI") {
              _this.scrollToFocusTab();
            }
          },
          key: index,
          role: 'presentation'
        }, rest),
        _react2.default.createElement(
          'span',
          { className: 'a-tab-bar-label' },
          icon,
          label && _react2.default.createElement(
            'span',
            { className: 'a-tab-bar-label-text' },
            label
          ),
          child.props.closable && _react2.default.createElement(_KeyboardHoverOnlyDiv2.default, { className: 'appkiticon icon-circle-delete-outline', onClick: child.props.close, isSpan: true, onKeyDown: function onKeyDown(e) {
              if (e.key === 'Enter') child.props.close(e);
            } })
        )
      )];
    };

    _this.state = {
      showPrevNext: false,
      next: true,
      prev: true,
      indicatorStyle: {
        width: 0,
        transform: 'translate3d(0px, -2px, 0px)'
      }
    };
    var o = _this;
    WebFont.load({
      custom: {
        families: ['PwC Helvetica Neue', 'PwC Helvetica Neue:n2,n3,n4,n5,n7,n9']
      },
      active: function active() {
        o.calcIndicatorStyle();
        o.setPrevNext();
      }
    });
    return _this;
  }

  _createClass(TabBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setPrevNext();
        _this2.calcIndicatorStyle();
      }, 200);

      window.addEventListener('resize', function () {
        _this2.setPrevNext();
        _this2.calcIndicatorStyle();
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      setTimeout(function () {
        var tabbarScroller = _this3.tabbarScroller;
        var currTabItem = tabbarScroller.querySelector(TAB_BAR_ITEM_ACTIVE_CLASS);
        if (!currTabItem) return;
        if (prevState.indicatorStyle.width !== currTabItem.scrollWidth + 1) {
          _this3.calcIndicatorStyle();
        }
      }, 0);
      //this timeout function is for supporting tabs in modal's condition.
      //Recaculate indicatorStyle when modal opens.
      if (prevProps.value && prevProps.value !== this.props.value || prevProps.children.length !== this.props.children.length) {
        this.calcIndicatorStyle();
        this.scrollToActiveTab();
        this.setPrevNext();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2,
          _this4 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          onKeyDown = _props.onKeyDown,
          onTabClick = _props.onTabClick,
          value = _props.value,
          tabBarClass = _props.tabBarClass,
          _props$size = _props.size,
          size = _props$size === undefined ? 'sm' : _props$size,
          _props$centered = _props.centered,
          centered = _props$centered === undefined ? false : _props$centered,
          _props$secondary = _props.secondary,
          secondary = _props$secondary === undefined ? false : _props$secondary,
          otherProps = _objectWithoutProperties(_props, ['className', 'children', 'onKeyDown', 'onTabClick', 'value', 'tabBarClass', 'size', 'centered', 'secondary']);

      var _state = this.state,
          showPrevNext = _state.showPrevNext,
          prev = _state.prev,
          next = _state.next;

      var tabbarWrapperClasses = (0, _classnames4.default)('a-tab-bar-wrapper', (_classnames2 = {}, _defineProperty(_classnames2, tabBarClass, tabBarClass), _defineProperty(_classnames2, 'a-tab-bar-' + size, size), _defineProperty(_classnames2, 'a-tab-centered', centered), _defineProperty(_classnames2, 'a-tab-bar-secondary', secondary), _classnames2));
      var tabbarClasses = (0, _classnames4.default)('a-tab-bar', {
        'a-tab-bar-scrolling': showPrevNext
      });
      var leftIconClasses = (0, _classnames4.default)('a-scroll-icon a-prev-icon', {
        'a-icon-show': showPrevNext,
        'a-icon-disabled': !prev
      });
      var rightIconClasses = (0, _classnames4.default)('a-scroll-icon a-next-icon', {
        'a-icon-show': showPrevNext,
        'a-icon-disabled': !next
      });

      if (children && !Array.isArray(children)) {
        children = [children];
      }

      return _react2.default.createElement(
        'div',
        Object.assign({
          className: tabbarWrapperClasses,
          ref: function ref(node) {
            return _this4.tabbarWrapper = node;
          }
        }, otherProps),
        _react2.default.createElement('div', { className: 'a-tab-bar-baseline' }),
        _react2.default.createElement(
          'span',
          {
            className: leftIconClasses,
            onClick: this.goPrev,
            onKeyDown: function onKeyDown() {}
          },
          _react2.default.createElement(
            'span',
            { className: 'a-icon-wrapper' },
            _react2.default.createElement('span', { className: 'appkiticon icon-left-chevron-circle-fill' })
          )
        ),
        _react2.default.createElement(
          'span',
          {
            className: rightIconClasses,
            onClick: this.goNext,
            onKeyDown: function onKeyDown() {}
          },
          _react2.default.createElement(
            'span',
            { className: 'a-icon-wrapper' },
            _react2.default.createElement('span', { className: 'appkiticon icon-right-chevron-circle-fill' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: tabbarClasses },
          _react2.default.createElement(
            'div',
            {
              className: 'a-overflow-wrapper',
              ref: function ref(node) {
                return _this4.tabbar = node;
              }
            },
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames4.default)('a-tab-bar-scroller', { "no-absolute-pos": centered && !showPrevNext }),
                ref: function ref(node) {
                  return _this4.tabbarScroller = node;
                }
              },
              children.length > 0 ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  children.map(function (child, index) {
                    return child ? _this4.renderTabBarItems(child, index) : null;
                  })
                ),
                _react2.default.createElement('span', { className: 'a-tab-bar-indicator', style: this.state.indicatorStyle })
              ) : ""
            )
          )
        )
      );
    }
  }]);

  return TabBar;
}(_react.Component);

TabBar.propTypes = {
  className: _propTypes2.default.string,
  secondary: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  tabbarClasses: _propTypes2.default.string,
  onTabClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  centered: _propTypes2.default.bool
};

TabBar.displayName = "TabBar";

exports.default = TabBar;